import { inputAdditionalValuesToInputAdditionalValue } from '@/context/services/reportsType/invoiceReports/useConvertApiDataAndReportForm';
import {
  CustomUpdateReportBodyParamsFormInputValue,
  InvoiceReportDetailFormInputsResponse,
  ReportSpecialExceptionStatus,
} from 'ap-openapi';
import { useCallback, useMemo } from 'react';
import { SpecialExceptionForm } from './type';
import { findReportFormInputType } from './useConvertApiDataAndPayeeForm';

export const useConvertApiDataToSpecialExceptionName = (
  reportFormInputs: InvoiceReportDetailFormInputsResponse[]
): SpecialExceptionForm => {
  const selectedSpecialExceptionInput: {
    id: string | undefined;
    value: string | undefined;
    options: {
      addressOrLocation: ReportSpecialExceptionStatus['address_or_location'];
    };
  } = useMemo(() => {
    const specialExceptionInput = findReportFormInputType(
      reportFormInputs,
      'ApReportFormInputSpecialExceptionStatus'
    );
    const addressOrLocation: ReportSpecialExceptionStatus | undefined =
      inputAdditionalValuesToInputAdditionalValue(
        specialExceptionInput?.input_additional_values
      );

    return {
      id: specialExceptionInput?.input_values?.[0]?.id,
      value: specialExceptionInput?.input_values?.[0]?.value,
      options: { addressOrLocation: addressOrLocation?.address_or_location },
    };
  }, [reportFormInputs]);

  const specialExceptionInput = findReportFormInputType(
    reportFormInputs,
    'ApReportFormInputSpecialExceptionStatus'
  );

  return useMemo(
    () =>
      ({
        ...selectedSpecialExceptionInput,
        reportForm: {
          specialException: {
            reportFormInputId: specialExceptionInput?.id,
            inputValueId: specialExceptionInput?.input_values?.[0]?.id,
          },
        },
      } satisfies SpecialExceptionForm),
    [
      selectedSpecialExceptionInput,
      specialExceptionInput?.input_values,
      specialExceptionInput?.id,
    ]
  );
};

export const useConvertSpecialExceptionToRequestForm = () => {
  return useCallback(
    (
      input: SpecialExceptionForm
    ): CustomUpdateReportBodyParamsFormInputValue[] => {
      const specialException: CustomUpdateReportBodyParamsFormInputValue = {
        report_form_input_id:
          input.reportForm.specialException.reportFormInputId,
        id: input.reportForm.specialException.inputValueId,
        value: input.value,
        options: {
          address_or_location: input?.options.addressOrLocation,
        },
        hasValueWithOptions: true,
      };

      return [specialException];
    },
    []
  );
};
